<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'app',
    data: () => ({
      tenant: ''
    }),
    methods: {
      updateTenant () {
        this.tenant = this.$store.state.tenant
      }
    },
    computed: {
      authenticated () {
        return this.$store.getters.cognitoAuthenticated
      }
    },
    created () {
      if (!this.cognitoAuthenticated && this.$router.currentRoute.fullPath.indexOf('/auth') !== 0) {
        this.$router.push({name: 'Login'})
      }
      this.updateTenant()
    },
    mounted () {

    }
  }
</script>

<style>
  /*
Must be separate from styles below
From CoreUI-Vue
*/
  $fa-font-path:"~font-awesome/fonts/";
  @import "~font-awesome/css/font-awesome.min.css";
  $simple-line-font-path: "~simple-line-icons/fonts/";
  @import "~simple-line-icons/css/simple-line-icons.css";
</style>

<style lang="scss">
  // Import Main styles for this application
  @import "./scss/style";
</style>



// WEBPACK FOOTER //
// src/App.vue?02259a36